<template>
  <panel :title="getVariationTitle()" :withFooter="!disabledInputs()" :withBody="!disabledInputs()" :onClick="value => onClickVariation(value)" :defaultSelect="variation.selected" :useAcordion="true" :blockSelect="variation.status === 'sent' || variation.status === 'error' || variation.status === 'cannotSend'">
    <div slot="header-right">
      <span v-if="variation.match && variation.match === true" class="badge-match" v-bind:class="badgeClass">{{ 'Match' }}</span>
      <span v-if="variation.status && variation.status !== 'sending'" class="badge" v-bind:class="badgeClass" :data-label="variation.message">{{ $t(variation.status).label }}</span>
    </div>

    <div class="l-row">
      <product-price :input="variation.price" :block="disabledInputs()" :module="fromModule" :sku="variation.sku"/>
    </div>

    <div class="l-row">
      <div class="l-col-6@md">
        <div class="l-row">
          <form-group label="EAN" :columns="6" :error="getError('ean', variation.sku)" v-if="!$slots['ean']" :required="isRequiredField()">
            <input class="form-input" type="text" v-model="variation.ean" :disabled="disabledInputs() || disabledInput('ean')">
          </form-group>
          <slot name="ean"></slot>

          <form-group label="Redutor" :columns="3" :error="getError('stock.reducer', variation.sku)" :required="true">
            <input class="form-input" type="number" min="0" v-model="variation.stock.reducer" :disabled="disabledInputs()">
          </form-group>

          <form-group label="Peso" :columns="3" :error="getError('weight', variation.sku)" :required="true">
            <div class="form-flex">
              <input class="form-input" type="text" v-model="variation.weight" :disabled="disabledInputs() || disabledInput('weight')">
              <span class="form-addon">g</span>
            </div>
          </form-group>
        </div>
      </div>

      <div class="l-col-6@md">
        <div class="l-row">
          <form-group label="Altura" :columns="4" :error="getError('height', variation.sku)" :required="true">
            <div class="form-flex">
              <input class="form-input" type="text" v-mask="'###.##'" v-model="variation.height" :disabled="disabledInputs() || disabledInput('height')">
              <span class="form-addon">cm</span>
            </div>
            <span v-if="toModule.identifier === 'cnova'"><small>(entre 1 e 700 cm)</small></span>
          </form-group>
          <form-group label="Largura" :columns="4" :error="getError('width', variation.sku)" :required="true">
            <div class="form-flex">
              <input class="form-input" type="text" v-mask="'###.##'" v-model="variation.width" :disabled="disabledInputs() || disabledInput('width')">
              <span class="form-addon">cm</span>
            </div>
            <span v-if="toModule.identifier === 'cnova'"><small>(entre 1 e 700 cm)</small></span>
          </form-group>
          <form-group label="Comprimento" :columns="4" :error="getError('length', variation.sku)" :required="true">
            <div class="form-flex">
              <input class="form-input" type="text" v-mask="'###.##'" v-model="variation.length" :disabled="disabledInputs() || disabledInput('length')">
              <span class="form-addon">cm</span>
            </div>
            <span v-if="toModule.identifier === 'cnova'"><small>(entre 1 e 700 cm)</small></span>
          </form-group>
        </div>
      </div>
    </div>
    <slot/>

    <image-variation :variation="variation"/>

  </panel>
</template>

<script>
  import ImageVariation from '@/components/marketplace/shared/provide/Image'
  import { mapGetters } from 'vuex'
  import Panel from '@/components/template/Panel'
  import ProductPrice from '@/components/shared/ProductPrice'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'

  export default {
    props: {
      variation: {
        type: Object,
        required: true
      },
      colors: {
        type: Object,
        required: false
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      },
      disabledInputList: {
        type: Array,
        default: () => []
      },
      account: {
        type: Object,
        required: false,
        default: null
      }
    },
    mounted () {
      const payload = {sku: this.variation.sku, source: this.fromModule}

      if (this.account && this.account.identifier) {
        payload.account = this.account
      }

      api.canProvide(this.toModule.type, this.toModule.identifier, payload)
        .then(() => {})
        .catch(error => {
          this.variation.status = 'cannotSend'
          this.variation.message = error.response.data.message
        })
    },
    methods: {
      getVariationTitle () {
        let title = [`SKU: ${this.variation.sku}`]

        if (this.variation.ean) {
          title.push(`EAN: ${this.variation.ean}`)
        }

        for (let i in Object.keys(this.variation.attributes)) {
          const attributeName = Object.keys(this.variation.attributes)[i]
          let attributeValue = this.variation.attributes[attributeName]

          if (attributeValue === null || attributeValue === undefined || attributeName === 'colorMap' || attributeName === 'sizeMap') {
            continue
          }

          if (typeof attributeValue !== 'string' && attributeValue.label !== undefined) {
            attributeValue = attributeValue.label
          }

          title.push(`${this.$t(`${attributeName}.label`)}: ${attributeValue}`)
        }

        title.push(`Estoque: ${this.variation.stock.quantity}`)

        return title.join(' | ')
      },
      isRequiredField () {
        let marketplaces = ['carrefour', 'cnova']

        if (marketplaces.includes(this.toModule.identifier)) {
          return true
        }

        return false
      },
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error' || this.variation.status === 'cannotSend'
      },
      onClickVariation (selected) {
        this.variation.selected = selected
      },
      disabledInput (input) {
        if (!this.disabledInputList.length) {
          return false
        }

        return this.disabledInputList.indexOf(input) !== -1
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      badgeClass () {
        let appendClass = ''
        if (this.variation.message) {
          appendClass = 'hint hint--left'
        }
        return `${this.variation.status} ${appendClass}`
      }
    },
    watch: {
      'variation.status' (value) {
        this.variation.selected = !!(value !== 'cannotSend')
        this.$emit('change', true)
      }
    },
    components: {
      Panel,
      ProductPrice,
      FormGroup,
      ImageVariation
    }
  }
</script>

<style lang="sass" scoped>
  .badge-match
    padding: 4px 8px 4px 8px
    color: #fff
    background-color: #4caf50
</style>



// WEBPACK FOOTER //
// Variation.vue?2124ea92